export const navigationConfig = [
    {
        title: 'Schedule',
        items: [
            { page: 'dashboard', label: 'Dashboard', icon: 'ph-house-line' },
            { page: 'library', label: 'Content Library', icon: 'ph-images' },
            { page: 'schedules', label: 'Schedules', icon: 'ph-clock' },
            { page: 'calendar', label: 'Calendar', icon: 'ph-calendar' },
        ],
    },
    {
        title: 'Monitor',
        items: [
            // { page: 'approvals', label: 'Approvals', icon: 'ph-check-circle' },
            // { page: 'content_recommendations', label: 'Recommendations', icon: 'ph-lightbulb' },
            // { page: 'content_auto_import', label: 'Auto Import', icon: 'ph-upload' },
            {
                page: 'analytics',
                label: 'Analytics',
                icon: 'ph-chart-line',
                hasDropdown: true,
                subItems: [
                    { page: 'account_analytics', label: 'Account' },
                    { page: 'post', label: 'Post' },
                    // { page: 'ad_analytics', label: 'Ad Analytics' },
                    // { page: 'ad_analytics_objective', label: 'Ad Analytics (Objective)' },
                    // { page: 'ad_analytics_campaign', label: 'Ad Analytics (Campaign)' },
                    // { page: 'analytics_reports', label: 'Reports' },
                    // { page: 'brand_settings', label: 'Brand Settings' },
                    { page: 'analytics_insights', label: 'Insights' },
                    { page: 'analytics_community', label: 'Community ' },
                    { page: 'hashtag_analytics', label: 'Hashtag ' },
                    { page: 'category_analytics', label: 'Content Tag' },
                    // { page: 'analytics_post_type', label: 'Post Type Analytics' },
                ],
            },
            {
                page: 'activity_feed',
                label: 'Activity Feed',
                icon: 'ph-list-bullets',
                hasDropdown: true,
                subItems: [
                    { page: 'recent_posts', label: 'Recent Posts' },
                    { page: 'direct_messages', label: 'Direct Messages' },
                    { page: 'mentions', label: 'Mentions' },
                    { page: 'listening', label: 'Social Listening' },
                ],
            },
            { page: 'inbox', label: 'Social Inbox', icon: 'ph-envelope-simple' },
        ],
    },
    // {
    //     title: 'Advanced',
    //     items: [
    //         { page: 'broadcast', label: 'Post Now', icon: 'ph-megaphone-simple' },

    //         // { page: 'historical', label: 'Grid Preview', icon: 'ph-calendar' },
    //     ],
    // },
    {
        title: 'Advanced',
        items: [
            { page: 'approvals', label: 'Approvals', icon: 'ph-check-circle' },
            { page: 'analytics_reports', label: 'Reports', icon: 'ph-file-text' },
            { page: 'brand_settings', label: 'Linked Accounts', icon: 'ph-link-break' },
        ],
    },
];
